import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminRequisitosDocumentalesPage } from "@/features/admin-gestion-documental/components/AdminRequisitosDocumentalesPage";

/** Ruta `/admin/requisitos-documentales` · Gestión Documental (fase 2) · requisitos por tipo/subtipo. */
export const Route = createFileRoute("/_authed-tw/admin/requisitos-documentales")({
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminGestionDocumental]}>
      <AdminRequisitosDocumentalesPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
